function buildAddressAttributes(address) {
  return {
    street: address.street,
    street_number: address.street_number,
    complement: address.complement,
    district: address.district,
    city: address.city,
    state: address.state,
    country: address.country,
    zip_code: address.zip_code.toString()
  };
}

function buildPhoneAttributes(phone) {
  return {
    country_code: phone.country_code,
    area_code: phone.area_code,
    number: phone.number
  };
}

function buildPaymentGatewayAccountAttributes(payload) {
  return {
    name: payload.account.first_name,
    alt_name: payload.account.last_name,
    document_type: payload.document.document_type,
    document_number: payload.document.document_number,
    phone: buildPhoneAttributes(payload.phone),
    address: buildAddressAttributes(payload.address)
  };
}

function buildPaymentGatewayAccountRelationships(account_id) {
  return { account: { data: { type: "accounts", id: account_id } } };
}

function createPGARequestBody(payload) {
  return {
    data: {
      type: "payment_gateway_accounts",
      attributes: buildPaymentGatewayAccountAttributes(payload),
      relationships: buildPaymentGatewayAccountRelationships(payload.account.id)
    }
  };
}

function createOnGatewayRequestBody(account_id) {
  return { data: { attributes: { account_id } } };
}

export default {
  createPGARequestBody,
  createOnGatewayRequestBody
};



// WEBPACK FOOTER //
// ./src/API/helpers/paymentGatewayAccount.js